import { carouselData } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-950 font-heading">{carouselData.title}</h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">{carouselData.subtitle}</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselData.items.map((item, i) => (
            <div key={i} className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer">
              <div className="relative h-52 md:h-56 overflow-hidden bg-background-100">
                <img
                  src={item.image}
                  alt={`焦点专题 - ${item.title}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    if (target.parentElement) target.parentElement.style.display = 'none';
                  }}
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-bold rounded-md whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">{item.title}</h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{item.excerpt}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}